import { verbozify } from '@/js/helpers/verbozify'

export function readableSnakeCase (value) {
  return verbozify(value)
}
